export const formatMaxTimeEstimate = (
  duration: number,
  format: "verbose" | "short" | "mobile" | "range",
  minDuration?: number,
) => {
  if (format === "mobile") {
    if (duration <= 30) {
      return "30 mins";
    }
    if (duration <= 60) {
      return "60 mins";
    }
    if (duration <= 90) {
      return "90 mins";
    }
    if (duration <= 120) {
      return "2 hours";
    }
    if (duration === 2880) {
      return "Next day";
    }
    if (duration <= 1440) {
      return "Same day";
    }
  }
  if (format === "verbose") {
    if (duration <= 30) {
      return "Delivery within 30 mins";
    }
    if (duration <= 60) {
      return "Delivery within 1 hour";
    }
    if (duration <= 90) {
      return "Delivery within 90 mins";
    }
    if (duration <= 120) {
      return "Delivery within 2 hours";
    }
  }
  if (format === "range") {
    if (duration === 0) {
      return "30 mins";
    }
    if (duration <= 90) {
      if (duration !== minDuration && minDuration !== undefined) {
        return `${minDuration} - ${duration} mins`;
      }
      return `${duration} mins`;
    }
    if (duration <= 120) {
      return "2 hours";
    }
    if (duration === 2880) {
      return "Next day";
    }
    if (duration <= 1440) {
      return "Same day";
    }
  }
  if (format === "short") {
    if (duration <= 30) {
      return "Delivery 30 mins";
    }
    if (duration <= 60) {
      return "Delivery 60 mins";
    }
    if (duration <= 90) {
      return "Delivery 90 mins";
    }
    if (duration <= 120) {
      return "Delivery 2 hours";
    }
  }
  if (duration === 2880) {
    return "Next day delivery";
  }
  if (duration <= 1440) {
    return "Same day delivery";
  }
  return "";
};
